<template>
    <div class="containers">
        <CModal
            size="sm"
            :centered="true"
            title="Informasi"
            color="info"
            :show.sync="warningModal"
            >
            <CRow>
                <CCol sm="4">
                    <span>Nama</span>
                </CCol>
                <CCol sm="8">
                    : {{nama}}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="4">
                    <span>Keterangan</span>
                </CCol>
                <CCol sm="8">
                    : {{keterangan}}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="4">
                    <span>Tanggal</span>
                </CCol>
                <CCol sm="8">
                    : {{waktu.split(" ")[0]}}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="4">
                    <span>Jam</span>
                </CCol>
                <CCol sm="8">
                    : {{waktu.split(" ")[1]}}
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol style="padding-right:4px" sm="8">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal" v-model="dates" class="form-control"/>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div style="width: 100%; height: auto;">
        <l-map
            :zoom="zoom"
            :center="center"
            style="height: 68.5vh; width: 100%"
        >
            <CAlert color="danger" style="z-index: 2999; text-align: center;" closeButton :show.sync="currentAlertCounter">
                {{errorMsg}}
            </CAlert>
            <l-tile-layer
            :url="url"
            :attribution="attribution"
            />
            <l-marker :lat-lng="checkIn.geo" @click="alert(checkIn.items)" v-if="checkIn.items!=null">
                <l-icon>
                    <!-- <div class="foto check-in"> -->
                        <!-- <b>{{checkIn.items.urlFoto}}</b> -->
                        <img class="foto" @error="changeDefault" :src="checkIn.items.urlFoto"/>
                    <!-- </div> -->
                </l-icon>
            </l-marker>
            <l-marker :lat-lng="checkOut.geo" @click="alert(checkOut.items)" v-if="checkOut.items!=null">
                <l-icon>
                    <!-- <div class="foto check-out"> -->
                        <!-- <b>{{checkOut.items.urlFoto}}</b> -->
                        <img class="foto" @error="changeDefault" :src="checkOut.items.urlFoto"/>
                    <!-- </div> -->
                </l-icon>
            </l-marker>
            <l-marker 
                v-if="activity.items != null"
                v-for="(item, index) in activity.items"
                :key="'act' + index"
                :lat-lng="item.geo"
                @click="alert(item.data)"
                >
                <l-icon>
                    <div class="foto p-1 activity">
                        <b>{{item.data.urlFoto}}</b>
                        <!-- <img :src="item.data.urlFoto"/> -->
                    </div>
                </l-icon>
            </l-marker>
        </l-map>
    </div>
</div>
</template>

<script>
    import {DataApi} from "../service/DataApi";
    import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
    import { latLng, icon } from "leaflet";  

    export default {
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LIcon
        },
        data() {
            return {
                nama: '',
                keterangan: '',
                latitude: '',
                longitude: '',
                waktu: '',
                warningModal: false,
                sampelImage: require('@/assets/image/images.svg'),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                zoom: 15,
                center: [-6.234970, 106.822545],
                foto: null,
                checkIn: {
                    items: null,
                    geo: [0,0]
                },
                activity: {
                    items:[]
                },
                checkOut: {
                    items: null,
                    geo: [0,0]
                },
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            currentAlertCounter: 0,
            errorMsg: '',
            // datas

            // paging

            // filter
            dates: null,

            // error
            
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        }
    },
    watch: {
        queryPegawai() {
            this.page = 1
            this.getDataPegawai()
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
         alert(item){
            this.warningModal = true
            this.nama = item.nama
            this.keterangan = item.keterangan
            this.latitude = item.latitude
            this.longitude = item.longitude
            this.waktu = item.waktu
        },
        getDataTracker(date, id) {
            let param = {
                idPegawai: parseInt(id),
                tanggal: date
            }
            this.activity.items = []
            this.checkIn.geo = [0,0]
            this.checkOut.geo = [0,0]
            DataApi.post("pegawai/maps", param).then(res => {
                var cek = res.data
                if(cek.success == true){
                    this.foto = cek.data[0].urlFoto
                    this.center = [cek.data[0].latitude, cek.data[0].longitude] 
                    cek.data.forEach((col)=>{
                        if(col.keterangan=='CheckIn'){
                            this.checkIn.geo = [col.latitude, col.longitude]
                            this.checkIn.items = col
                        } else if (col.keterangan=='CheckOut'){
                            this.checkOut.geo = [col.latitude, col.longitude]
                            this.checkOut.items = col
                        } else if (col.keterangan=='Activities'){
                            this.activity.items.push({
                                data: col,
                                geo:[col.latitude, col.longitude]
                            })
                        }
                    })
                } else {
                    this.errorMsg = 'Data tidak ditemukan!'
                    this.currentAlertCounter = 3
                    this.queryPegawai = ''
                    this.selectedItemPegawai = null
                    this.dates = null
                }
            })
        },
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },

        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
                return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.queryPegawai = this.selectedItemPegawai.text
            this.visiblePegawai = false;
            if (this.shouldReset) {
                this.queryPegawai = '';
                this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
                return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
                return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
        //

        /**
         * SEARCH UNIT LEVEL
         */
         findData() {
            if(this.dates == null || this.selectedItemPegawai == null){
                this.errorMsg = 'Anda belum mengisi semua field!'
                this.currentAlertCounter = 3
            } else {
                this.getDataTracker(this.dates, this.selectedItemPegawai.value)
            }
        },
        changeDefault(e) {
            e.target.src = this.sampelImage
        },
    },
    mounted() {
        delete L.Icon.Default.prototype._getIconUrl;
        this.getDataPegawai()
    }
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:52%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:47%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:42%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:32%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:57%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    z-index: 9999;
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.foto{
  border-radius: 50%;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 40px !important;
  height: 40px !important;
  object-fit: cover;
  margin: 0 !important;
  color: white;
  background-color: #d0d0d0;
  font-size: 1.25rem;
  border: 1px solid #0E86D4;
}
.check-in {
  background-color: #0E86D4;
}
.check-out {
  background-color: #BA0F30;
}
.activity {
  background-color: #32CD30;
}

</style>